// Front
// Authentication Module
import { rootReducer } from "saga-slice";
import authModule from "./sagas/authSlice";
import productSlice from "./sagas/productSlice";
import saleModule from "./sagas/saleSlice";
import stockSlice from "./sagas/stockSlice";
import supplierSlice from "./sagas/supplierSlice";
import refundSlice from "./sagas/refundSlice";
import inventorySlice from "./sagas/inventorySlice";
import purchaseModule from "./sagas/purchaseSlice";

const modules = [authModule, productSlice, saleModule, stockSlice, supplierSlice, stockSlice, refundSlice, inventorySlice, purchaseModule];

const appReducer = rootReducer(modules, {
  
});

export default appReducer;
